var map = {
	"./Union_5.svg": "bda0",
	"./ab.svg": "9102",
	"./anounce-new.svg": "9ad4",
	"./anounce.svg": "5935",
	"./arrow-collapse.svg": "b11e",
	"./arrow-go-right.svg": "723d",
	"./arrow-right-small.svg": "a814",
	"./arrow-right.svg": "cd8c",
	"./arrow-up.svg": "a3f8",
	"./arrow_drop.svg": "526b",
	"./calculator.svg": "250e",
	"./calendar.svg": "b8bd",
	"./check.svg": "7bae",
	"./check_icon_land.svg": "d4e1",
	"./check_land_sales.svg": "2253",
	"./click.svg": "e902",
	"./clock.svg": "755b",
	"./close.svg": "8b1b",
	"./down-arrow.svg": "fcc4",
	"./facebook.svg": "8485",
	"./favorite.svg": "2bd7",
	"./filter-mobile.svg": "182a",
	"./filter.svg": "2376",
	"./grid-items.svg": "649f",
	"./grid.svg": "4b05",
	"./id.svg": "29f9",
	"./instagram.svg": "bd6c",
	"./left-arrow.svg": "6d4b",
	"./link.svg": "40a1",
	"./list-items.svg": "2fc9",
	"./list.svg": "99ad",
	"./login-new.svg": "4410",
	"./login.svg": "ca2f",
	"./loop.svg": "b0e2",
	"./mail-send.svg": "1c01",
	"./mail.svg": "3ae9",
	"./manager.svg": "f955",
	"./mobile.svg": "0df4",
	"./mouse-header.svg": "eaee",
	"./move-map.svg": "34ba",
	"./msg.svg": "c051",
	"./pdf.svg": "5730",
	"./phone-header.svg": "0b06",
	"./phone-new.svg": "cc95",
	"./phone_promo.svg": "17cb",
	"./pin-footer.svg": "d239",
	"./pin-marker.svg": "62db",
	"./pin-sales-mobile.svg": "5317",
	"./pin.svg": "862b",
	"./pin_land.svg": "d9e9",
	"./play.svg": "dab1",
	"./precent.svg": "86ed",
	"./print.svg": "671e",
	"./promo_insta.svg": "3cf0",
	"./red-alert-icon.svg": "febe",
	"./reload.svg": "b9c2",
	"./resize-gal.svg": "ded6",
	"./resize.svg": "605c",
	"./resize_noll.svg": "7a84",
	"./right-arrow.svg": "c686",
	"./sale-pin.svg": "1fc8",
	"./sales-all-mobile.svg": "538d",
	"./social-footer.svg": "9b3d",
	"./sort.svg": "f931",
	"./star-sales.svg": "a55e",
	"./star.svg": "cc90",
	"./telapp.svg": "6713",
	"./telegram.svg": "2b29",
	"./tenge.svg": "abbd",
	"./user-icon.svg": "149a",
	"./user.svg": "6aed",
	"./vk.svg": "13e3",
	"./wapp.svg": "0f62",
	"./warning_online.svg": "2870",
	"./whatsapp.svg": "7583",
	"./zoom.svg": "6705"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";